<template>
  <section class="hero is-medium video is-primary">
    <div class="hero-video-bg">
      <video playsinline autoplay muted loop :src="bannerVideo">
      </video>
    </div>
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 v-if="title" class="title is-2">{{ title }}</h1>
        <button
          class="button mt-5"
          @click="
            this.showModal = true;
            noscroll();
          "
        >
          {{ bannerButton }}<i class="fas fa-video"></i>
        </button>
      </div>
    </div>

    <transition name="modal">
      <Modal v-if="this.showModal" @close="this.showModal = false">
        <template v-slot:body>
          <video
            class="modal-video"
            controls=""
            id="showreelVideo"
            v-if="showModal"
            :poster="showreel !== undefined && showreel.split(' | ')[1]  ? showreel.split(' | ')[1] : null"
          >
            <source
              :src="showreel.split(' | ')[0]"
              type="video/mp4"
            />
          </video>
        </template>
      </Modal>
    </transition>
  </section>
</template>

<script>
import Modal from "./Modal.vue";
import Spinner from "./Spinner.vue";

export default {
  name: "Hero",
  components: { Spinner, Modal },
  props: {
    title: {
      type: String,
      default: null,
    },
    bannerButton: {
      type: String,
      default: null,
    },
    bannerVideo: {
      type: String,
      default: null,
    },
    showreel: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    noscroll() {
      const html = document.querySelector("html");
      html.classList.add("is-clipped");
    },
  },
};
</script>

<style scoped>
.spinner-wrapper {
  position: absolute;
  left: calc(50% - 25px);
  top: calc(50% - 25px);
}
.hero {
  position: relative;
}
.hero:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.hero-body {
  z-index: 2;
}
.hero-video-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  overflow: hidden;
}
.hero-video-bg video {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}
.button {
  background: transparent;
  border: 2px solid #fff;
  color: #fff;
  margin: 20px 0;
}
.button:hover {
  background-color: #fff;
  cursor: pointer;
  color: var(--getty-black);
}
.button svg {
  opacity: 1;
}

.modal-video {
  height: calc(100vh - 100px);
  width: 100%;
}

@media (max-width: 734px) {
  .title.is-2 {
    font-size: 2rem;
  }
}
@media (max-width: 550px) {
  .hero-video-bg video {
    min-width: 200%;
  }
}
</style>